import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardData: {},
  isLoading: false,
  error: null,
};

const audioDashboardSlice = createSlice({
  name: "audioDashboard",
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setDashboardData, setLoading, setError } =
  audioDashboardSlice.actions;

export default audioDashboardSlice.reducer;
